import * as tool from "./_tools.js";
import * as SL from "./_storeLocator.js";


export const localisation = {
    ville: "",
    codePostal: "",
};

async function getLocalisation(lat, long) {
    let api =
        "https://api-adresse.data.gouv.fr/reverse/?lon=" + long + "&lat=" + lat;
    let response = await fetch(api);
    return response.json();
}

/**
 * Retrieves the geolocation of the user and updates the localisation object.
 *
 * @return {Promise} A promise that resolves when the localisation object is updated, or rejects with an error message.
 */
function geoLocalisation() {
    return new Promise((resolve, reject) => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(async function (position) {
                let lat = position.coords.latitude;
                let long = position.coords.longitude;
                let response = await getLocalisation(lat, long)
                    .then((r) => r)
                    .catch((e) => console.log(e));
                if (response) {
                    let ville = response.features[0].properties.city;
                    let codePostal = response.features[0].properties.postcode;
                    localisation.ville = ville;
                    localisation.codePostal = codePostal;
                    resolve("Localisation updated");
                } else {
                    reject("Failed to get localisation");
                }
            });
        } else {
            reject("Geolocation not supported");
        }
    });
}

/**
 * Asynchronously handles geolocation input.
 *
 * @return {Promise<void>} A promise that resolves when the function completes.
 */

export async function inputGeoLocalisation() {
    try {
        await geoLocalisation()
            .then((r) => console.log(r))
            .catch((e) => console.log(e));
        const addressInput = document.querySelector("#form-field-communeHome");
        const codePostal = localisation.codePostal;
        const list = document.getElementsByClassName("input-city")[0];
        let svgLocalisation =
            '<svg fill="#e40c19" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 297 297" xml:space="preserve"> <path d="M148.5,0C87.43,0,37.747,49.703,37.747,110.797c0,91.026,99.729,179.905,103.976,183.645 c1.936,1.705,4.356,2.559,6.777,2.559c2.421,0,4.841-0.853,6.778-2.559c4.245-3.739,103.975-92.618,103.975-183.645 C259.253,49.703,209.57,0,148.5,0z M148.5,272.689c-22.049-21.366-90.243-93.029-90.243-161.892 c0-49.784,40.483-90.287,90.243-90.287s90.243,40.503,90.243,90.287C238.743,179.659,170.549,251.322,148.5,272.689z" ></path> <path d="M148.5,59.183c-28.273,0-51.274,23.154-51.274,51.614c0,28.461,23.001,51.614,51.274,51.614 c28.273,0,51.274-23.153,51.274-51.614C199.774,82.337,176.773,59.183,148.5,59.183z M148.5,141.901 c-16.964,0-30.765-13.953-30.765-31.104c0-17.15,13.801-31.104,30.765-31.104c16.964,0,30.765,13.953,30.765,31.104 C179.265,127.948,165.464,141.901,148.5,141.901z" ></path></svg>';
        if (addressInput) {
            addressInput.addEventListener("click", () => {
                if (codePostal) {
                    new SL.StoreLocatorSearch(codePostal, addressInput, '#submit-button');
                    tool.waitForElem(".commune").then((r) => {
                        if (codePostal === r.getAttribute("data-code_postal")) {
                            list.classList.remove("hide");
                            if (!document.querySelector(".localisation")) {
                                let logoLocalisation = document.createElement("span");
                                logoLocalisation.setAttribute("class", "localisation");
                                logoLocalisation.setAttribute("aria-hidden", "true");
                                logoLocalisation.innerHTML = svgLocalisation;
                                r.prepend(logoLocalisation);
                            }
                        }
                    });
                } else {
                    list.classList.remove("hide");
                    document.querySelectorAll(".input-city").forEach((input) => {
                        input.classList.remove("hide");
                    });
                }
            });
        }
        tool.waitForElem(".commune").then((r) => {
            const input = document.querySelector(".input-city");
            if (
                !r.classList.contains("hide") &&
                !input.classList.contains("hide")
            ) {
                document.querySelector(".page-content").addEventListener(
                    "click",
                    tool.throttle(function (e) {
                        if (e.target !== r && e.target !== input) {
                            list.innerHTML = "";
                            list.classList.add("hide");
                            input.classList.add("hide");
                        }
                    }, 50)
                );
            }
        });
    } catch (e) {
        console.log(e);
    }
}
